import { Component, OnInit, Input, AfterViewInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeadingSectionType01Component } from "../../heading-section/heading_section-type01/heading_section-type01.component";
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { FormsModule } from '@angular/forms';

declare var GenesysApi: any;

@Component({
  selector: 'app-newsletters-type03',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule, SlickCarouselModule, FormsModule],
  templateUrl: './newsletters-type03.component.html',
  styleUrl: './newsletters-type03.component.scss'
})
export class NewslettersType03Component implements OnInit, AfterViewInit {
  
  @Input() clientId!: string;
  @Input() formId!: string;
  @Input() integration: 'popup' | 'iframe' | 'bar';

  // Popup
  @Input() buttonText: string = 'Subscribe';
  @Input() buttonId: string = 'subscribeBtn';

  // Iframe
  @Input() iframeId: string = 'subscribeIframe';
  @Input() iframeWidth: string = '100%';
  @Input() iframeHeight: string = '400px';

  // Bottom bar
  @Input() signupText: string = 'Subscribe to our Newsletter Here >';
  @Input() barButtonText: string = 'Subscribe';
  @Input() emailPlaceholder: string = 'Enter email here';
  @Input() barId: string = 'bottomBar';

  public view: any = {
  }

  constructor(public _tfmService : TFMService, private route: ActivatedRoute) {

  }

  ngOnInit(): void {
      this._tfmService.getSite().then(res => {
        this.view.site = res;

        this.view.site.profile = this._tfmService.getSiteProfile(this.view.site.profileID);
        // this._tfmService.log(this.view);

      });
  }

  ngAfterViewInit(): void {
    if (typeof GenesysApi === 'undefined') return;

    switch (this.integration) {
      case 'popup':
        GenesysApi.subscribeButton(this.clientId, this.formId, this.buttonText, this.buttonId);
        break;
      case 'iframe':
        GenesysApi.showForm(this.clientId, this.formId, this.iframeId, this.iframeWidth, this.iframeHeight);
        break;
      case 'bar':
        GenesysApi.subscribeBar(this.clientId, this.formId, this.signupText, this.barButtonText, this.emailPlaceholder, this.barId);
        break;
    }
  }
}
